module.exports = __webpack_public_path__ + "img/quick-ship.46a0d34f.svg";